import clsx from "clsx";
import type { ComponentProps } from "react";

import { HomeGridCards } from "@features/home-grid-cards";

import type { EventType } from "@/_pages/event/model";

import type { PageType } from "../model";
import { AllEvents } from "./all-events";
import { Hero } from "./hero";

import s from "./EventsPage.module.scss";

export type EventsPageProps = ComponentProps<"div"> & {
  events: EventType[];
  page: PageType;
};

export const EventsPage = (props: EventsPageProps) => {
  const { events, page } = props;

  return (
    <div className={clsx(s.root)}>
      <Hero events={page.heroEvents} title={page.title} />
      <AllEvents events={events} />
      <HomeGridCards
        {...page.gridMediaList}
        pageIcon={
          page.pageIcon || {
            fillColor: "milk",
            strokeColor: "gold",
            icon: {
              name: "plus",
            },
          }
        }
      />
    </div>
  );
};

EventsPage.displayName = "EventsPage";
